<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		
	
		<div class="">
			<el-form inline ref="form" :model="searchform">

			

					<el-form-item class="mb-0 mr-0">
						 <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					<el-form-item class="mb-0 mr-0">
						 <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
					</el-form-item>
					<el-form-item  class="mb-0" style="margin-right:0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0 mr-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		
		</div>
    <div class="text-muted  ml-2"><span class="text-danger ml-2 mr-2">{{$t('searchText.입금계')}}:{{formatMoney(inm)}}</span>|<span class="text-primary ml-2 mr-2">{{$t('searchText.출금계')}}:{{formatMoney(outm)}}</span>|<span class="text-success ml-2">{{$t('searchText.차액')}}:{{formatMoney(inm-outm)}}</span></div>
	
	</div>
   

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @sort-change='tableSortChange'>
    
        <el-table-column
        type="index"
        width="50">
      </el-table-column>
     

    
         <el-table-column
        :label="$t('nav.아이디')" prop="io_id" align="center" width="140">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
             <span @click="openModel(scope.row.io_id)" class="text-primary" style="cursor:pointer;">{{scope.row.io_id}}</span>
           </div>
          </template>
      </el-table-column> 

      <el-table-column
       :label="$t('tableText.이름')" prop="mem_name" align="center" width="150">
          <template slot-scope="scope">
            
             {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
          </template>
      </el-table-column> 

     

     

      <el-table-column
        :label="$t('msg.입금')"
         prop="inm" align="center" sortable="custom">
        <template slot-scope="scope">{{ formatMoney(scope.row.inm)}}</template>

      </el-table-column>
       <el-table-column
        :label="$t('msg.출금')"
       prop="outm" align="center" sortable="custom">
        <template slot-scope="scope">{{ formatMoney(scope.row.outm)}}</template>

      </el-table-column>

      <el-table-column
        :label="$t('searchText.차액')"
         prop="ce" align="center" sortable="custom">
         <template slot-scope="scope"><span :class="scope.row.inm - scope.row.outm < 0 ?'text-danger':'text-primary'">{{ formatMoney(scope.row.inm - scope.row.outm)}}</span></template>
      </el-table-column>  
     
     

      
     <el-table-column
         :label="$t('searchText.시작')"
        prop="mindate" align="center">
      </el-table-column>
		
		 <el-table-column
         :label="$t('searchText.마감')"
        prop="maxdate" align="center">
      </el-table-column>


    </el-table>
     <div style="height: 100px;"></div>
                     
       
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
 import layerNew from '../../components/common/layer-new.vue';

    export default {
     components: {
      layer,
      layerNew
    },
    	data(){
    		return{
           order:'',
           prop:'',
           level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")              
            },
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
            bg:window.sessionStorage.getItem('bg'),
            userid:window.sessionStorage.getItem('userid'),
             aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
    
    			options: [{
	              label:this.$i18n.t("msg.대기"),
	              value: '1',
	             
	            }, {
	              label: this.$i18n.t("msg.처리중"),
	               value: '2',
	              
	            }, {
	              label: this.$i18n.t("msg.완료"),
	               value: '3',
	             
	            }, {
	              label: this.$i18n.t("msg.취소"),
	               value: '4',
	             
	            }], 
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    			
		        {
		        	label: this.$i18n.t("nav.아이디"),
		        	value:'io_id'
		        },
		       
		       

		        ],
		      
		        value:'',



    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
                
        

		    		 loading: false,

		    		 creatModel:false,
		    		 tableData: [],
             inm:'',
             outm:'',
			        
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			console.log('cccc')
    		this.getList();
		   },
          
    	
    	methods:{
              tableSortChange(column) {
 
                     this.prop= column.prop
                     this.order= column.order
                     
                    this.getList()
                 },
         // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         openModel(id){

          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                 area: ['990px', '700px'],
             
             });
              return;
           }
           
          this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	 this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }
                this.currentPage=1;

    			this.getList();
    			
             

    		},
    		
			    
			     
    		getList(){

    		   

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');

                 if(token==null)
                 {
                      
                 }
    			 
    			 let urls=this.domain+'/admin/inout_by_user?fit='+this.prop+'&order='+this.order+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   // /  console.log('data=',response.data.data)
                     let data = response.data.data
                     this.tableData =data
                     this.inm = response.data.inm
                     this.outm = response.data.outm
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
               this.loading = false
               
            })
    		},
    		
    		
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px 20px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
</style>


// WEBPACK FOOTER //
// src/views/inout/list.vue